import { cn } from 'lib/utils';
import type { ParsedDelimitedTable } from '../utils/assistant-file-preview';

type AssistantCsvTablePreviewProps = {
  table: ParsedDelimitedTable;
  className?: string;
};

/** Claude-style CSV/TSV table preview: header band, horizontal rules only. */
export const AssistantCsvTablePreview = ({ table, className }: AssistantCsvTablePreviewProps) => {
  const { headers, rows } = table;

  return (
    <div className={cn('h-full w-full overflow-auto bg-background', className)}>
      <div className="min-w-full px-4 py-4 md:px-6">
        <div className="w-full overflow-x-auto">
          <table className="w-full min-w-max border-collapse text-left text-sm">
            <thead>
              <tr className="bg-[#f5f5f5] dark:bg-muted/50">
                {headers.map((header, index) => (
                  <th
                    key={`header-${index}`}
                    scope="col"
                    className="whitespace-nowrap border-b border-border px-4 py-2.5 text-sm font-semibold text-foreground"
                  >
                    {header || `Column ${index + 1}`}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td
                    colSpan={Math.max(headers.length, 1)}
                    className="px-4 py-8 text-center text-sm text-muted-foreground"
                  >
                    No rows in this table.
                  </td>
                </tr>
              ) : (
                rows.map((row, rowIndex) => (
                  <tr key={`row-${rowIndex}`}>
                    {row.map((cell, cellIndex) => (
                      <td
                        key={`cell-${rowIndex}-${cellIndex}`}
                        className="whitespace-nowrap border-b border-border/40 px-4 py-2.5 align-top text-sm text-foreground"
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
